import classNames from 'classnames';
import React from 'react';
import round from 'utils/round';

export const ImprovementMetricDisplay = ({improvement, className}) => (
  <div
    className={classNames(
      className,
      improvement > 0 && 'positive',
      improvement < 0 && 'negative',
      improvement === 0 && 'neutral'
    )}>
    {improvement > 0 ? '+' : ''}
    {improvement === undefined ? 'N/A' : round(improvement, 2) + '%'}
  </div>
);
